import { licensesStoreInitialData } from "./InitialData"

export type LicensesStoreTableType = {
  name: string
  id: number
  price: number
}

export type MembersAssignedToLicense = {
  username: string
  email: string
  expires: string
}

const convertToLicensesStoreReport = (data: licensesStoreInitialData): LicensesStoreTableType[] => {

  const licenses = data?.licenses ?? []

  const licenseData = licenses.map(license => ({
    name: license.name ?? '',
    id: license.id ?? 0,
    price: license.price ?? 0
  }));

  return licenseData;
  
}

export const LicensesStoreTableData = (data: licensesStoreInitialData): LicensesStoreTableType[] => {
  return convertToLicensesStoreReport(data)
}
